import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { Check, Sparkles } from "lucide-react";

const NAVY  = "#1A1A2E";
const EMBER = "#FF6B35";
const TEAL  = "#00BFA5";

// There is no checkout step any more: a retailer's subscription is created by Fyrris
// (create-retailer-subscription) and the invoice arrives by email, so this page no longer
// verifies a Stripe Checkout session. It only welcomes the retailer and continues to the portal.
export default function PortalWelcome() {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    if (countdown <= 0) {
      navigate("/portal", { replace: true });
      return;
    }
    const t = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown, navigate]);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
      style={{ backgroundColor: NAVY }}
    >
      <Helmet>
        <title>Welcome to Fyrris</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div
        className="w-16 h-16 rounded-full flex items-center justify-center mb-6"
        style={{ backgroundColor: `${TEAL}22` }}
      >
        <Check className="w-9 h-9" style={{ color: TEAL }} />
      </div>

      <div className="flex items-center gap-2 mb-3">
        <Sparkles className="w-5 h-5" style={{ color: EMBER }} />
        <Sparkles className="w-5 h-5" style={{ color: EMBER }} />
      </div>

      <p className="text-xl font-semibold text-white mb-2">Welcome to Fyrris</p>
      <p className="text-sm text-gray-400 mb-6">Taking you to your portal in {countdown}…</p>

      <button
        onClick={() => navigate("/portal", { replace: true })}
        className="rounded-full px-6 py-2.5 text-sm font-semibold text-white transition hover:opacity-90"
        style={{ backgroundColor: EMBER }}
      >
        Go to my portal
      </button>
    </div>
  );
}
